import Discussion from 'flarum/common/models/Discussion';
import commonExtend from '../common/extend';
import Extend from 'flarum/common/extenders';
import Post from 'flarum/common/models/Post';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import deckColumns from './deck/deckColumns';
export default [...commonExtend, new Extend.Model(Discussion) //
.hasOne('bestAnswerPost').hasOne('bestAnswerUser').attribute('hasBestAnswer').attribute('bestAnswerSetAt', Model.transformDate), new Extend.Model(User) //
.attribute('bestAnswerCount'), new Extend.Model(Post) //
.attribute('canSelectAsBestAnswer'), ...('flarum-deck' in flarum.extensions ? [deckColumns()] : [])];